import { ChipTypeEnums } from "constants/enums";

/**
 * Maps a Model Task filter chips array ({ chipType, id, value }) to the
 * search params the paged task list endpoint expects. A chipType of
 * Undefined is a free-text "Contains" chip (added via Enter in the search
 * box); every one present becomes an entry in `textSearches`.
 */
export const processModelTaskChipsForAPI = (chips = []) => {
	const params = {
		textSearches: [],
		roleIds: [],
		intervalIds: [],
		zoneIds: [],
		stageIds: [],
		arrangementIds: [],
	};

	if (!Array.isArray(chips)) {
		return params;
	}

	chips.forEach((chip) => {
		if (chip.chipType === ChipTypeEnums.Undefined) {
			const value = chip.value?.trim();
			if (value) params.textSearches.push(value);
			return;
		}

		if (chip.id == null) return;
		const id = parseInt(chip.id);
		switch (chip.chipType) {
			case ChipTypeEnums.Role:
				params.roleIds.push(id);
				break;
			case ChipTypeEnums.Interval:
				params.intervalIds.push(id);
				break;
			case ChipTypeEnums.Zone:
				params.zoneIds.push(id);
				break;
			case ChipTypeEnums.Stage:
				params.stageIds.push(id);
				break;
			case ChipTypeEnums.Arrangement:
				params.arrangementIds.push(id);
				break;
			default:
				break;
		}
	});

	return params;
};
